import { Landmark } from 'lucide-react';
import { cn } from '../../lib/utils.js';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
export function MeetingBodyAvatar(_a) {
    var meetingBody = _a.meetingBody, governmentLogoUrl = _a.governmentLogoUrl, className = _a.className, fallbackClassName = _a.fallbackClassName, fallbackIconClassName = _a.fallbackIconClassName;
    return (<Avatar className={cn('h-16 w-16 rounded-md border', className)}>
      <AvatarImage src={meetingBody.logoUrl || governmentLogoUrl || undefined} alt={"".concat(meetingBody.name, " logo")}/>
      <AvatarFallback className={cn('rounded-md', fallbackClassName)}>
        <Landmark className={cn('text-muted-foreground h-8 w-8', fallbackIconClassName)}/>
      </AvatarFallback>
    </Avatar>);
}
